<template>
  <div>
    <b-modal id="modal-1" title="Edit Music" hide-footer>
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
          <div>
            <div class="mt-4">
              <FileUploader
                v-show="!image"
                :image="image"
                :onSuccess="handleSuccess"
                class="rounded-full widtht30percent m-auto display-none custmodal"
              />
              <img
                v-if="image"
                :src="
                  image.slice(0, 4) === 'data' ? image : `${$imageURL}/${image}`
                "
                ref="cover"
                class="rounded-full widtht20percent m-auto display-none custmodal"
              />
              <div
                class="text-center text-red"
                v-if="image"
                @click="handleRemove"
              >
                Remove image
              </div>
              <p class="text-center">Upload your cover photo</p>
            </div>
            <b-form-group label="Music name">
              <base-input
                v-model="name"
                :rules="{ required: true }"
                placeholder="Music name"
                name="Music"
              ></base-input>
            </b-form-group>
            <!-- <b-form-group label="Producer">
            <base-input
              v-model="producer"
              placeholder="Enter Producer name"
              name="Producer"
            ></base-input>
            v-show="selectedImage && currentPage === 'Podcast'"
          </b-form-group> -->
            <audio controls :src="soundUrl + '/' + song2"></audio>
            <div class="">
              <p>Select Music Please</p>
              <b-form-file
                v-model="song"
                @change="filesChange"
                accept="audio/*"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              ></b-form-file>
              <span v-if="audioErr" class="small text-danger">{{
                msg.audio
              }}</span>
            </div>

            <div class="flex justify-center mt-2">
              <b-button type="submit" variant="primary">Save</b-button>
            </div>
          </div>
        </b-form>
      </validation-observer>
    </b-modal>
    <div class="flex gap-4">
      <div class="w-full">
        <b-input-group class="">
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            v-model="search"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
              @click="getMeditation"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
    <el-table
      border
      :data="tableData"
      style="width: 100%"
      class="mt-4 rounded"
      header-row-class-name="thead-light table-th-color "
    >
      <el-table-column
        label="Sr. No"
        type="index"
        :index="indexMethod"
        width="80px"
      >
      </el-table-column>
      <el-table-column prop="image" label="Image" width="250px">
        <template slot-scope="scope">
          <img
            :src="`${$imageURL}/${scope.row.image}`"
            :alt="scope.row.name"
            class="width100"
          />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="Music name"> </el-table-column>
      <!-- <el-table-column prop="producer" label="Producer" width="">
      </el-table-column> -->
      <el-table-column
        label="Edited By"
        prop="editedby"
        min-width="130px"
        sortable
      >
        <template slot-scope="scope">
          <p
            class="font-semibold text-left name mb-0 text-sm"
            v-if="scope.row.isEdited"
          >
            {{
              scope.row.editedByName[0].firstname +
                " " +
                scope.row.editedByName[0].lastname || " "
            }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="Actions"
        min-width="80px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <div class="flex" @click="getSingleMeditation(scope.row._id)">
              <feather-icon
                icon="Edit2Icon"
                svgClasses="w-4 text-blue-600 cursor-pointer"
                class="ml-2"
                v-b-modal.modal-1
              ></feather-icon>
            </div>

            <div class="flex" @click="handleDeleteMeditation(scope.row._id)">
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 text-red-600 cursor-pointer"
                class="ml-2"
              ></feather-icon>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </b-card-footer>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import _ from "lodash";
import { mapState } from "vuex";
import FileUploader from "../../../../../components/FileUploader.vue";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    FileUploader,
  },
  data() {
    return {
      image: null,
      name: "",
      song: null,
      song2: null,
      search: "",
      totalRows: 0,
      meditationId: "",
      perPage: 5,
      currentPage: 1,
      audioErr: false,
      msg: {
        image: "",
        audio: "",
      },
      soundUrl: process.env.VUE_APP_IMAGE_URL,
      tableData: [
        // {
        //   date: "2",
        //   title: "Tom",
        //   desc: "No. 189, Grove St, Los Angeles",
        // },
        // {
        //   date: "2",
        //   title: "Tom",
        //   desc: "No. 189, Grove St, Los Angeles",
        // },
        // {
        //   date: "2",
        //   title: "Tom",
        //   desc: "No. 189, Grove St, Los Angeles",
        // },
      ],
    };
  },
  methods: {
    filesChange(event) {
      let mByte = 5 * 1048576;
      if (event.target.files[0].size > mByte) {
        this.song = null;
        event = {};
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        this.audioErr = true;
        this.msg.audio = "File size exceeds the allowed limit!";
      } else {
        this.audioErr = false;
        if (!event.target.files[0].type.includes("audio")) {
          this.song = null;
          event = {};
          this.audioErr = true;
          this.msg.audio = "Upload Audio File Only";
        } else {
          this.audioErr = false;
          this.song = event.target.files[0];
        }
      }
    },
    indexMethod(index) {
      return this.perPage * (this.currentPage - 1) + index + 1;
    },
    // handleAddMeditation(val = false, item = {}) {
    //   this.isAddtestActive = val;
    //   this.selectaddMeditation = item;
    // },
    handleEditMeditation(val = false, item = {}) {
      this.isEditTestActive = val;
      this.selectEditMeditation = item;
    },
    async handleDeleteMeditation(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData(id) {
      let loader;
      let payload = {
        meditationId: id,
      };
      loader = this.$loading();
      try {
        const data = await this.$store.dispatch(
          "meditation/deleteMeditation",
          payload
        );
        loader.close();
        if (data.code === 200) {
          this.getMeditation();
          await this.$swal({
            text: "Meditation Deleted successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
      } catch (err) {
        console.log(err);
        loader.close();
      }
    },
    async getMeditation() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        let loader = this.$loading();
        const getMeditation = await this.$store.dispatch(
          "meditation/getMeditation",
          payload
        );
        // console.log(getMeditation);
        loader.close();
        this.totalRows = this.meditation.totalCount;
        let meditationData = this.meditation.result;
        this.tableData = meditationData;
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;

      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    async onSubmit() {
      this.name = this.name.trim();

      const payload = new FormData();
      payload.append("meditationId", this.meditationId);
      if (this.name) payload.append("name", this.name);
      if (this.song) payload.append("song", this.song);
      if (this.coverImage) payload.append("image", this.coverImage);

      let loader;

      try {
        // console.log(payload);
        loader = this.$loading();
        const editMeditation = await this.$store.dispatch(
          "meditation/editMeditation",
          payload
        );

        if (editMeditation.code === 200) {
          // console.log(editMeditation);
          loader.close();
          this.closeModal();
          this.getMeditation();
          await this.$swal({
            text: "Meditation Updated Successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });

          this.name = "";
          this.song = null;
          this.coverImage = null;
          this.image = null;
          this.meditationId = "";
        }
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async getSingleMeditation(id) {
      let loader;
      try {
        let payload = {
          meditationId: id,
        };
        this.meditationId = id;

        loader = this.$loading();
        const getMeditationdata = await this.$store.dispatch(
          "meditation/getMeditation",
          payload
        );

        if (getMeditationdata.code === 200) {
          if (getMeditationdata.data.result[0].name) {
            this.name = getMeditationdata.data.result[0].name;
          }
          if (getMeditationdata.data.result[0].song) {
            this.song2 = getMeditationdata.data.result[0].song;
          }
          if (getMeditationdata.data.result[0].image) {
            this.image = getMeditationdata.data.result[0].image;
          }
        }

        loader.close();
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    closeModal() {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-1");
      });
    },
  },
  watch: {
    // isAddtestActive(val) {
    //   if (!val) {
    //     this.getMeditation();
    //   }
    // },
    isEditTestActive(val) {
      if (!val) {
        this.getMeditation();
      }
    },
    async currentPage() {
      await this.getMeditation();
    },
    search: {
      handler: _.debounce(async function (val) {
        this.getMeditation();
      }, 500),
    },
  },
  computed: {
    ...mapState("meditation", {
      meditation: "meditation",
    }),
  },
  async mounted() {
    await this.getMeditation();
  },
};
</script>

<style>
.width100 {
  width: 100px;
  height: 100px !important;
}
</style>
